import { Browser } from '@syncfusion/ej2-base';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { AccumulationChart, IAccLoadedEventArgs, AccumulationTheme} from '@syncfusion/ej2-angular-charts';

import { MenuFuncionService, GastoService } from '../../../../../src/app/shared/services';
import { DashboardGastosPorTipoGastoRequest, LocalStorageKeys, MenuFuncionCodes } from '../../../../../src/app/shared/model';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-gasto-tipo-gastos',
  templateUrl: './gasto-tipo-gastos.component.html',
  styleUrls: ['./gasto-tipo-gastos.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class GastoTipoGastosComponent implements OnInit, OnDestroy {
  chart: AccumulationChart;
  canView: boolean = false;
  isValidating: boolean = false;
  isSearching: boolean = false;

  public data:Object[] = [];
  // Initializing Legend
  public legendSettingsGastoTipoGasto?: Object;
  public tooltipGastoTipoGasto?: Object;

  // custom code start
  public load(args: IAccLoadedEventArgs): void {
    let selectedTheme: string = location.hash.split('/')[1];
    selectedTheme = selectedTheme ? selectedTheme : 'Material';
    args.accumulation.theme = <AccumulationTheme>(
      (selectedTheme.charAt(0).toUpperCase() +
        selectedTheme.slice(1)).replace(/-dark/i, 'Dark').replace(/contrast/i, 'Contrast')
    );
  }

  // custom code end
  public startAngle: number = Browser.isDevice ? 55 : 35;
  public radius: string = Browser.isDevice ? '50%' : '70%'
  public enableAnimation: boolean = true;

  private subscription: Subscription;

  constructor(
    private menuService: MenuFuncionService,
    private sharedFunctions: SharedFunctions,
    private gastoService: GastoService,
    private eventEmitterService: EventEmiterService
    ) {
      this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
        this.loadView()
      });
    }

  ngOnInit() {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_GASTOS_TIPO_GASTO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    var tenantId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId);
    if (tenantId != null && tenantId.length > 0) {
      var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
      if (cId != null && cId.length > 0 && cId > 0)
        cId = Number(cId);

      var r = new DashboardGastosPorTipoGastoRequest(cId);
      this.isSearching = true;

      this.gastoService.obtenerDashboardGastosPorTipoGasto(r).subscribe((response) => {
        this.isSearching = false;
        if (response != null && response.Success) {
          this.legendSettingsGastoTipoGasto = {
            width: '200', height: '250',shapeHeight: 15, shapeWidth: 15
          };
          this.tooltipGastoTipoGasto = {
            enable: true
          }

          this.data = response.Result?.Grupos;
        }
      },
      (err: HttpErrorResponse) => {
        this.isSearching = false;
        this.sharedFunctions.handleError(err);
      })
    }
    else {
      setTimeout(() => this.loadView(), 1000);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
